import axios from "axios";
import router from '../router';
import store from '../store';
import {SERVER_URL, DEVELOPMENT_SERVER_URL} from "../config/server";

axios.defaults.withCredentials = true

const service = axios.create({
    baseURL: process.env.NODE_ENV == 'development'
        ? DEVELOPMENT_SERVER_URL
        : SERVER_URL,
    headers: {
        "Content-Type": "application/json;charset=utf-8",
    },
    timeout: 600000,
});

service.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('index-token'),
            loginUrl = '/monitor/login',
            loginOut = "/loginOut";
        if (config.url == loginUrl) {
            return config;
        }
        if (token) {
            let thatToken = store.state.token;
            if (thatToken != token && config.url != loginOut) {
                store.commit('loginOut');
                let error = new Error("登录账号有问题！");
                return Promise.reject(error);
            }
            config.headers.token = token;
        } else {
            store.commit('loginOut');
            let error = new Error("请登录！");
            return Promise.reject(error);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
)

service.interceptors.response.use(
    (response) => {
        if (response.data.code == 400003) {
            store.commit('loginOut');
        }
        return response.data
    },
    (error) => {
        return Promise.reject(error);
    }
)

export default service;

// 通用下载方法
export function download(url, params, filename = null) {
    axios({
        method: 'post',
        url: SERVER_URL + url,
        data: params,
        responseType: 'blob',
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            'token': localStorage.getItem('index-token'),
        }
    }).then(res => {
        if (!filename) {
            filename = decodeURIComponent(res.headers['content-disposition'].split('filename=')[1]).replace(/\"/g, "");
        }
        const content = res.data;
        const blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
            const elink = document.createElement("a");
            elink.download = filename;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
        } else {
            navigator.msSaveBlob(blob, filename);
        }
    })
}
